import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL, USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';
import { PaginatedChats } from '../../../../interfaces/chat/paginatedStore.type';
import deviceInfoAxios from '../../../../utils/axios/deviceInfo.axios';

const tryToFetchChats = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedChats>> => {
    const url = filters
        ? `${USERS_API_URL}/chatbox/chat/rebecca?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/chatbox/chat/rebecca?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.put<PaginatedChats>(url, { filters: data });
};

const tryToFetchAllChats = (): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/chatbox/chat/rebecca/all`);
};

const tryToCreateChatMessage = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.put(`${USERS_API_URL}/rebecca-users/sign-up/by-admin`, data);
};

const tryToCreateChatMessageExecu = (data: any): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.post(`${DEVICE_INFO_API_URL}/rebecca-ai-agent/staff-feedback`, data);
};

const tryToUploadChatFiles = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.post(`${USERS_API_URL}/hotel-world-user-invites/upload-chat-files`, data);
};

export const ChatsService = {
    tryToFetchChats,
    tryToFetchAllChats,
    tryToCreateChatMessage,
    tryToCreateChatMessageExecu,
    tryToUploadChatFiles
};